import { Menu, MenuItem, Skeleton } from '@getgo/chameleon-web-react-wrapper'
import { Box } from '@material-ui/core'

const PartnerToolsDrawerSkeleton = () => {
  return (
    <Menu data-testid="partner-tools-drawer-skeleton">
      <Box pt={2} pb={2}>
        <MenuItem>
          <Skeleton variant="rectangle" size="small" />
        </MenuItem>
        <MenuItem>
          <Skeleton variant="rectangle" size="small" />
        </MenuItem>
        <MenuItem>
          <Skeleton variant="rectangle" size="small" />
        </MenuItem>
      </Box>
      <Box pt={2} pb={2}>
        <MenuItem>
          <Skeleton variant="rectangle" size="small" />
        </MenuItem>
        <MenuItem>
          <Skeleton variant="rectangle" size="small" />
        </MenuItem>
      </Box>
      <Box pt={2} pb={2}>
        <MenuItem>
          <Skeleton variant="rectangle" size="small" />
        </MenuItem>
        <MenuItem>
          <Skeleton variant="rectangle" size="small" />
        </MenuItem>
      </Box>
    </Menu>
  )
}

export default PartnerToolsDrawerSkeleton
